import axios from 'axios'
import { BASE_URL_STRIPE, CART_IS_LOADING, CART_IS_NOT_LOADING } from '../actions'
import { ICartItem, ICoupon } from '../interface'
import { Dispatch, AnyAction } from 'redux'
import { removeAdditionalSeats } from '../utils/bizzabo'
import { analyticsRemoveProductAndAdditionalSeats } from './analytics'

/**
 * Remove a product from the cart. If the product is a bizzabo product and it's not an additional seat,
 * we have to check if there are additional seats associated with it and remove them as well.
 */
export const removeProductFromCart = (cart: ICartItem[], element: ICartItem) => {
  analyticsRemoveProductAndAdditionalSeats({ cart, element })
  removeAdditionalSeats(cart, element)
  return cart.filter((cartItem) => {
    const bizzaboFilter =
      !cartItem.bizzaboEventId || (cartItem.bizzaboEventId && cartItem.bizzaboSessionId === element.bizzaboSessionId)

    // Keep the item only if productId or boxId is different, or if the bizzabo date is different
    return cartItem.productId !== element.productId || cartItem.boxId !== element.boxId || bizzaboFilter === false
  })
}

export const getTimeWithoutTimezone = () => {
  return Date.now() - new Date().getTimezoneOffset() * 60 * 1000
}

/**
 * Retrieves coupon from stripe
 */
export const retrieveCoupon = async (
  couponId?: string,
  dispatch?: Dispatch<AnyAction>
): Promise<ICoupon | undefined> => {
  let response: ICoupon | undefined = undefined
  if (!couponId) return response
  try {
    if (dispatch) dispatch({ type: CART_IS_LOADING })
    const url = `${BASE_URL_STRIPE}/coupon`
    const request = await axios.get(url, { params: { couponId } })
    if (request.data.valid) {
      response = request.data as ICoupon
    }
    return response
  } catch (error) {
    console.error('Error on retrieveCoupon', error)
  } finally {
    if (dispatch) dispatch({ type: CART_IS_NOT_LOADING })
  }
}
